let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("7wl6B")).then(() => parcelRequire('fGJ6I'));